export const scrollInToView = (ref) => {
    ref.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}